











































import {Component} from 'vue-property-decorator'
import axios from 'axios'
import {apiV1AdminEventPath, apiV1AdminEventUserPath} from '@/rails/routes'
import Event, {IEvent} from '@/models/Event'
import EventUser from '@/models/EventUser'
import EventUserList from '@/components/admin/events/UserList.vue'
import PageBase, {BreadCrumb} from '@/pages/page-base'
import {saveAs} from 'file-saver'
import * as dayjs from 'dayjs'

@Component({
  components: {
    EventUserList
  }
})
export default class EventShow extends PageBase {
  event = new Event()
  activeUsers: Array<EventUser> = []
  selectedActiveUsers: Array<number> = []
  nonActiveUsers: Array<EventUser> = []
  selectedNonActiveUsers: Array<number> = []

  async mounted(): Promise<void> {
    try {
      super.mounted()
      await this.reload()
      this.loading = false
    } catch (e) {
      console.error(e)
    }
  }

  async reload(): Promise<void> {
    const res = await axios.get<IEvent>(apiV1AdminEventPath(this.$route.params.id))
    this.event = new Event(res.data)
    this.activeUsers = this.event.event_users.filter(user => user.active)
    this.nonActiveUsers = this.event.event_users.filter(user => !user.active)
  }

  async destroy(): Promise<void> {
    const selectedActiveUsers = this.selectedActiveUsers.map(au => this.activeUsers[au])
    const selectedNonActiveUsers = this.selectedNonActiveUsers.map(au => this.nonActiveUsers[au])
    const targets = selectedActiveUsers.concat(selectedNonActiveUsers)
    if (!window.confirm(`選択した${targets.length}名のユーザーの参加をキャンセルします、よろしいですか？`)) {
      return
    }
    this.showLoading()
    for (let i = 0; i < targets.length; i++) {
      const target = targets[i]
      await axios.delete(apiV1AdminEventUserPath(target.id))
    }
    await this.reload()
    this.selectedActiveUsers = []
    this.selectedNonActiveUsers = []
    this.hideLoading()
    this.showMessage('選択したユーザーのイベント参加をキャンセルしました')
  }

  async download(): Promise<void> {
    this.showLoading()
    const res = await axios.get(apiV1AdminEventPath(this.$route.params.id, { format: 'xlsx' }), {
      responseType: 'blob'
    })
    const blob = new Blob([res.data], )
    saveAs(blob, `event_${this.$route.params.id}_${dayjs().format('YYYYMMDD_HHmm')}.xlsx`)
    this.hideLoading()
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: 'イベント一覧',
        to: '/admin/events',
        exact: true
      },
      {
        text: 'イベント詳細'
      }
    ]
  }
}
